import {
    apiRequest,
    golonganDetail
} from "../../../../../services/adapters/kepegawaian/golonganService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", golonganDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository